import React from 'react';
import { useT } from '../../../../../features/src/i18n/index';
import { FooterNavLink, LinkType } from '../Components/FooterNavLink';
import { Type } from '@spotify-internal/encore-web-v6';
import styled from 'styled-components';
import { TRACK_CAT } from '../constants';

const LinkList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
`;

export const CreatorTools = () => {
  const t = useT();
  const links: LinkType[] = [
    {
      href: 'https://www.soundtrap.com/?utm_source=spotify_site&utm_medium=footer_menulink&utm_campaign=alwayson_global_soundtrap_destination',
      track: [TRACK_CAT, 'Creator Tools - Soundtrap'],
      dataTestId: 'footer-soundtrap',
      label: 'Soundtrap',
      prefetch: true,
      external: true,
    },
    {
      href: 'https://podcasters.spotify.com/?utm_source=artists.spotify.com',
      track: [TRACK_CAT, 'Creator Tools - Spotify for Podcasters'],
      dataTestId: 'footer-s4p',
      label: 'Spotify for Podcasters',
      prefetch: true,
      external: true,
    },
    {
      href: 'https://noteable.spotify.com/?utm_source=artists.spotify.com',
      track: [TRACK_CAT, 'Creator Tools - Noteable'],
      dataTestId: 'footer-spa',
      label: 'Noteable',
      prefetch: true,
      external: true,
    },
  ];
  return (
    <>
      <Type variant="finaleBold" semanticColor="textBase">
        {t('FRODOR_d0bb36', 'Creator tools', '').toUpperCase()}
      </Type>
      <LinkList>
        {links.map(link => {
          return <FooterNavLink key={link.label} link={link} />;
        })}
      </LinkList>
    </>
  );
};
